import { alphaNumericValidatorWithSpecialCharacters, numberValidator } from 'common/utils/validator';
import { IFORM_ELEMENT, IFORM } from '../FormBuilder';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Datepicker from 'b2b-ui-components-lib/lib/components/datePicker';
import { getRange } from 'common/utils/app.utils';
import { FILE_MAX_SIZE } from 'common/constants/app.constants';

export const DEFAULT_FORM_CONFIG: IFORM = {
  purchaseOrderNo: {
    key: 'purchaseOrderNo',
    isMandatory: true,
    value: '',
    label: 'Purchase Order No',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: { type: Input }
  },
  purchaseOrderDate: {
    key: 'purchaseOrderDate',
    isMandatory: true,
    value: '',
    label: 'Purchase Order Date',
    element: {
      type: Datepicker,
      props: {
        maxDate: new Date(),
        minDate: new Date(new Date().getTime() - 45 * 24 * 60 * 60 * 1000),
        years: getRange(new Date(new Date().getTime() - 45 * 24 * 60 * 60 * 1000).getFullYear(), new Date().getFullYear())
      }
    }
  },
  purchaseOrderTotalCharges: {
    key: 'purchaseOrderTotalCharges',
    isMandatory: true,
    value: '',
    label: 'Purchase Order Total Charges',
    element: { type: Input },
    validator: numberValidator
  },
  purchaseOrderExpiryDate: {
    key: 'purchaseOrderExpiryDate',
    isMandatory: true,
    value: '',
    label: 'Purchase Order Expiry Date (Optional)',
    element: {
      type: Datepicker,
      props: {
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
        minDate: new Date(),
        years: getRange(new Date().getFullYear(), new Date().getFullYear() + 5)
      }
    }
  },
  Alpha: { key: 'Test', isMandatory: true, value: '', label: 'Test', validator: alphaNumericValidatorWithSpecialCharacters, element: { type: Input } }
};
const DOCUMENT_TYPE_ENUM = {
  SEZ: 'SEZ',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  AUTHORIZED_SIGNATORY: 'AUTHORIZED_SIGNATORY'
};

export const PO_FILE_SCHEMA = {
  supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  maxFileLimit: FILE_MAX_SIZE,
  documentNames: ['PO_DOCUMENT', 'PO_DOCUMENT_2', 'PO_DOCUMENT_3'],
  documentType: DOCUMENT_TYPE_ENUM.PURCHASE_ORDER,
  allowMultiplePDFs: true
};
